import { useFinancialContexts } from '../contexts/ContextsContext';
import type { FinancialContext } from '../services/contextApi';
import { canLinkTelegramGroup } from '../utils/contextPermissions';

/**
 * Where a message to Fin lands for the context in focus. The private chat
 * always records into the personal view, so a group is reached only through
 * its own Telegram group, or not yet at all.
 */
export type FinChannel =
  | { kind: 'personal' }
  | { kind: 'groupChat'; groupName: string; chatTitle: string | null; url: string | null; needsAdmin: boolean }
  | { kind: 'noGroupChat'; contextId: string; groupName: string; canAddFin: boolean };

export const finChannelOf = (context?: FinancialContext | null): FinChannel => {
  if (!context || context.type === 'personal') {
    return { kind: 'personal' };
  }
  const chat = context.telegramChats?.[0];
  if (chat) {
    return { kind: 'groupChat', groupName: context.name, chatTitle: chat.title, url: chat.url ?? null, needsAdmin: Boolean(chat.needsAdmin) };
  }
  return { kind: 'noGroupChat', contextId: context.id, groupName: context.name, canAddFin: canLinkTelegramGroup(context.memberRole) };
};

export const useFinChannel = (): FinChannel => {
  const { selectedContext } = useFinancialContexts();
  return finChannelOf(selectedContext);
};
